/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon24Solid = forwardRef('ArrowDim2DiagMaxRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.5 1.75a1.25 1.25 0 1 0 0 2.5h3.482l-5.366 5.366a1.25 1.25 0 0 0 1.768 1.768l5.366-5.366V9.5a1.25 1.25 0 1 0 2.5 0V4.25a2.5 2.5 0 0 0-2.5-2.5H14.5Z" }),
        React.createElement("path", { d: "M11.384 14.384a1.25 1.25 0 0 0-1.768-1.768L4.25 17.982V14.5a1.25 1.25 0 1 0-2.5 0v5.25a2.5 2.5 0 0 0 2.5 2.5H9.5a1.25 1.25 0 1 0 0-2.5H6.018l5.366-5.366Z" })));
});
